export function formatDate(value?: string | null) {
  if (!value) return "Unpublished";
  return new Intl.DateTimeFormat("en-ZW", {
    day: "numeric",
    month: "short",
    year: "numeric"
  }).format(new Date(value));
}
